import './BasketWidgetItem.css';
import {removeFromCart} from "../../../CartHandler.js";
import {useBasket} from "../../../context/BasketContext/BasketContext.jsx";
import {useNotification} from "../../../context/NotificationContext/NotificationContext.jsx";
import React from "react";

export default function BasketWidgetItem({item}) {
    const { basketVersion, bumpBasketVersion } = useBasket();

    const {displayNotification,setDisplayNotification} = useNotification();
    const removeItem = async ()=>{
        await removeFromCart(item.item.id)
            .then(() => {
                bumpBasketVersion();
                setDisplayNotification({type:'error',message:`Produkt${item.quantity>1 ? "y" : ""} został pomyślnie usunięty z koszyka!`});
            })
    }
    return <div className="basket-widget-item">
        <div className="basket-widget-item-image"
        >
            <img loading="lazy" src={item.item.img} alt={item.item.alt || item.item.name || 'Produkt'} />

        </div>
        <div className="basket-widget-item-data-wrapper">
            <div className="basket-widget-item-name">{item.item.name}</div>
            <span className="basket-widget-item-price">{item.quantity} x {(item.item.price).toFixed(2)} zł</span>
            {item.item.options[0].value!=="Default Title" && <div className="basket-widget-item-details">
                { item.item.options.map((o,index)=>{
                    if(o.name==="Kolor"){
                        return <span className='basket-widget-item-detail' key={`bi${index}`}>{o.name}: <div className='basket-widget-item--color' style={{backgroundColor:o.value}}></div></span>
                    }
                    return <span key={`bi${index}`} className='basket-widget-item-detail'>{o.name}: {o.value}</span>
                })}
            </div>}
        </div>
        <div className="basket-widget-item-price-total">{(item.item.price*item.quantity).toFixed(2)} zł</div>
        <div className="basket-widget-item-remove-bttn"
         onClick={removeItem}>
            <img loading="lazy" src='/images/close-icon.webp' alt="" />

        </div>

    </div>;
}
